import { render, staticRenderFns } from "./mClass.vue?vue&type=template&id=39455e80&scoped=true&"
import script from "./mClass.vue?vue&type=script&lang=js&"
export * from "./mClass.vue?vue&type=script&lang=js&"
import style0 from "./mClass.vue?vue&type=style&index=0&id=39455e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39455e80",
  null
  
)

export default component.exports